<div class="title-wrap">
  <app-common-page-title icon="assets/luckera/icons/icon-profile-header.png"><ng-container i18n>Profile</ng-container></app-common-page-title>
</div>
<div class="profile-info">
  <!-- <div fxLayoutAlign="start center" fxLayout="row" class="title-wrap">
    <app-header-page-compoanent iconName="icon-profile-header.svg">Profile </app-header-page-compoanent>

  </div> -->
  <div class="content">
    <div class="profile-wrapper desktop" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
      <div fxFlex class="top-container">
        <div class="user-details" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
          <!-- <ng-container *ngIf="avatar"> -->
            <div class="vip-avatar" *ngIf="userRole else regularAvatar">
              <div class="vip-img-content">
                <img class="vip-player-img" src="{{avatar}}" />
                <div class="role" i18n>vip</div>
              </div>
              <img class="vip-leef" src="{{licenceService.getKey('icon-vip-leef')}}">
            </div>
            <ng-template #regularAvatar>
              <img class="regular-player-img" src="{{avatar}}" />
            </ng-template>
          <!-- </ng-container> -->
          <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="12px">
            <div *ngIf="verified && !kyc_status" class="verified max-width-inherit" i18n>Verified</div>
            <div [ngSwitch]="kyc_status">
              <div *ngSwitchCase="'account unverified'">
                <div class="upload_doc-status unverified-status"><img src="{{licenceService.getKey('icon-unverified-badge')}}" alt="icon-unverified-badge"><span i18n class="max-width-inherit">ACCOUNT UNVERIFIED</span></div>
              </div>
              <div *ngSwitchCase="'upload documents'">
                <div class="upload_doc-status"><img src="{{licenceService.getKey('icon-upload-doc-badge')}}" alt="icon-upload-doc-badge"><span i18n class="max-width-inherit">UPLOAD DOCUMENTS</span></div>
              </div>
              <div *ngSwitchCase="'verification in progress'">
                <div class="upload_doc-status verification-status"><img src="{{licenceService.getKey('icon-verification-badge')}}" alt="icon-verification-badge"><span i18n class="max-width-inherit">VERIFICATION IN PROGRESS</span></div>
              </div>
              <div *ngSwitchCase="'account verified'">
                <div class="upload_doc-status verified-status"><img src="{{licenceService.getKey('icon-verified-badge')}}" alt="icon-verified-badge"><span i18n class="max-width-inherit">ACCOUNT VERIFIED</span></div>
              </div>
            </div>
            <div class="email" i18n>{{email}}</div>
          </div>
        </div>
      </div>
      <!-- <div fxFlex class="level-container" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="12px">
        <div class="level-container-img-box">
          <div class="image" [ngStyle]="{'background': userRole ? 'var(--image-border-gradient)' : 'var(--image-border)'}">
        <div class="icon-player-level">
            <img *ngIf="lemonIconNameIndex" src="assets/luckera/icons/level-icon/icon-level-{{lemonIconNameIndex}}.svg" alt="icon-gamification" />
        </div>
            <div *ngIf="playerLoyalityName" class="label" [ngClass]="{'vip-label':userRole}">{{playerLoyalityName}}</div>
          </div>
          <div class="label-level" i18n>{{playerLevelPosition}}</div>
        </div>
        <div class="level-progress-container" fxLayout="column" fxLayoutGap="8px">
          <div class="level-progress-number" fxLayout="row" fxLayoutAlign="space-around center">
            <div *ngFor="let levelValue of playerCurrentLevelList" class="number" [ngClass]="{ 'completed': gamificationLevel > levelValue, 'current': levelValue == gamificationLevel }">{{levelValue}}</div>
          </div>
          <div class="profile-level-progress">
            <mat-progress-bar color="accent" mode="determinate" [value]="gamificationTotalLevelPercent" [ngClass]="gamificationTotalLevelPercent===100 ? 'value-comleted' : 'value-not-comleted'">
            </mat-progress-bar>
            <div class="level-divider-container" fxLayout="row" fxLayoutAlign="space-evenly center">
              <div class="level-divider"></div>
              <div class="level-divider"></div>
              <div class="level-divider"></div>
              <div class="level-divider"></div>
            </div>
            <div class="current-number-percent" [ngStyle]="{'left.%':gamificationTotalLevelPercent}">
              <div class="percent-up-arrow"></div>
              <div class="percent-number" *ngIf="gamificationPercentFill < 100 else PercentFill">{{gamificationPercentFill.toFixed(2)}}%</div>
              <ng-template #PercentFill>
                <div class="percent-number">{{gamificationPercentFill.toFixed(0)}}%</div>
              </ng-template>
            </div>
          </div>
        </div>
        <div class="level-container-img-box">
          <div class="image">
            <div class="icon-player-level">
              <img *ngIf="lemonNextLevelIconNameIndex" src="assets/luckera/icons/level-icon/icon-level-{{lemonNextLevelIconNameIndex}}.svg" alt="icon-gamification" />
            </div>
            <div *ngIf="playerNextLoyalityName" class="label" [ngClass]="{'vip-label':userRole}">{{playerNextLoyalityName}}</div>
          </div>
          <div class="label-level" i18n>{{playerNextLevelPosition}}</div>
        </div>
      </div> -->
    </div>

    <div class="items" [ngStyle]="{'grid-template-columns':cashBackTwoActive ? '1fr 1fr' : '1fr 1fr 1fr'}">
      <div class="item-wrapper light" [ngClass]="{'active-Lottery': bonusQueue?.length > 0}">
        <div class="item">
          <div class="spinner-container">
            <div class="spinner-background">
              <div class="icon-player-level">
                <!-- <img *ngIf="isPrizeBoxActive && showGamification" src="{{licenceService.getKey('level-1-icon')}}" alt="icon-gamification" />
                <img *ngIf="!isPrizeBoxActive && showGamification" src="{{licenceService.getKey('level-1-icon')}}" alt="icon-gamification" /> -->
                <img *ngIf="isPrizeBoxActive || !lemonIconNameIndex" src="{{licenceService.getKey('icon-bonus-drop')}}" />
                <span *ngIf="!isPrizeBoxActive && lemonIconNameIndex" style="margin-top: -4px;">{{lemonIconNameIndex}}</span>
            </div>
            </div>
            <mat-progress-spinner #spinnerlevel color="accent" mode="determinate" [value]="gamificationPercentFill" [diameter]="64" style="stroke-linecap: round;">
            </mat-progress-spinner>
          </div>
          <div class="text-container">
            <div class="title" i18n>My Bonuses</div>
            <div i18n>Collect your prize!</div>
            <!-- <div *ngIf="isPrizeBoxActive" i18n>Collect your prize!</div>
            <div *ngIf="!isPrizeBoxActive" style="color: #E4DCD1;"><span i18n>Level</span> {{gamificationLevel}} <span i18n>completed in</span> {{gamificationPercentFill.toFixed(2)}}%</div> -->
          </div>

          <div class="info">
            <a [routerLink]="bonusesUrl" rel="noreferrer" routerLinkActive="active">
              <img src="{{licenceService.getKey('icon-info')}}" />
            </a>
          </div>
        </div>
        <!-- <button round-button filled="filled" color="yellow" (click)="openPrizeBox()" [disabled]="!isPrizeBoxActive" i18n>Open!</button> -->
        <button round-button filled="filled" color="yellow" i18n [routerLink]="bonusesUrl" [disabled]="bonusQueue?.length == 0|| !bonusQueue" routerLinkActive="active">Action</button>
      </div>

      <div class="item-wrapper light" [ngClass]="{'active-Lottery': userBonusLotteryResponse}">
        <div class="item">
          <div class="icon-container">
            <img *ngIf="userBonusLotteryResponse" src="{{licenceService.getKey('icon-bonus-wheel')}}" />
            <img *ngIf="!userBonusLotteryResponse" src="{{licenceService.getKey('icon-bonus-wheel')}}" />
          </div>
          <div class="text-container">
            <div class="title" i18n>Luckera Wheel</div>
            <div *ngIf="userBonusLotteryResponse" i18n>Claim your free ticket!</div>
            <div *ngIf="!userBonusLotteryResponse" style="color: #E4DCD1;" i18n>No active spin</div>
          </div>
          <div class="info">
            <a routerLink="/info/luckera-wheel" rel="noreferrer" routerLinkActive="active">
              <img src="{{licenceService.getKey('icon-info')}}">
            </a>
          </div>
        </div>
        <button round-button filled="filled" [disabled]="!userBonusLotteryResponse" color="yellow" (click)="openLotteryWheel()" i18n>Spin!</button>
      </div>

      <div class="item-wrapper light" [ngClass]="{'active-Lottery': userChargebackToClaim}">
        <div class="item">
          <div class="spinner-container">
            <div class="spinner-background" [ngClass]="{'spinner-background-active':!!userChargebackToClaim && showGamification}">
              <img src="{{licenceService.getKey('icon-daily-cashback')}}" alt="icon-gamification" />
              <!-- <img *ngIf="!!userChargebackToClaim && showGamification" src="{{licenceService.getKey('icon-daily-cashback')}}" alt="icon-gamification" /> -->
            </div>
            <mat-progress-spinner *ngIf="!userChargebackToClaim" #spinnerlevel color="accent" mode="determinate" [value]="chargebackPercentFill" [diameter]="64" style="stroke-linecap: round;">
            </mat-progress-spinner>
            <mat-progress-spinner *ngIf="!!userChargebackToClaim" #spinnerlevel color="accent" mode="determinate" [value]="100" [diameter]="64" style="stroke-linecap: round;">
            </mat-progress-spinner>
          </div>
          <div class="text-container">
            <div class="title" i18n>Cashback:</div>
            <div class="cash">{{(!!userChargebackToClaim? userChargebackToClaim : userChargeback)?.value?.toFixed(2)}} {{(!!userChargebackToClaim? userChargebackToClaim : userChargeback)?.currency}}</div>
            <div *ngIf="!userChargebackToClaim && dailyChargebackFormatted" style="color: #E4DCD1;"><span i18n>Next payout in:</span>&nbsp;{{dailyChargebackFormatted}}</div>
          </div>
          <div class="info">
            <a [routerLink]="cashbackInfoUrl" rel="noreferrer" routerLinkActive="active">
              <img src="{{licenceService.getKey('icon-info')}}">
            </a>
          </div>
        </div>
        <button round-button filled="filled" [disabled]="!userChargebackToClaim" color="warn" (click)="claimCashback()" i18n>Claim!</button>
      </div>

      <div *ngIf="cashBackTwoActive" class="item-wrapper light" [ngClass]="{'active-Lottery': userChargebackToClaim}">
        <div class="item">
          <div class="spinner-container">
            <div class="spinner-background" [ngClass]="{'spinner-background-active':!!userChargebackToClaim && showGamification}">
              <img *ngIf="!userChargebackToClaim && showGamification" src="assets/client-area/icon-cashback-2-off.png" alt="icon-gamification" />
              <img *ngIf="!!userChargebackToClaim && showGamification" src="assets/client-area/icon-cashback-2-on.png" alt="icon-gamification" />
            </div>
            <mat-progress-spinner *ngIf="!userChargebackToClaim" #spinnerlevel color="accent" mode="determinate" [value]="chargebackPercentFill" [diameter]="64" style="stroke-linecap: round;">
            </mat-progress-spinner>
            <mat-progress-spinner *ngIf="!!userChargebackToClaim" #spinnerlevel color="accent" mode="determinate" [value]="100" [diameter]="64" style="stroke-linecap: round;">
            </mat-progress-spinner>
          </div>
          <div class="text-container">
            <div i18n>Cashback 2 earned:</div>
            <div class="title" i18n>{{(!!userChargebackToClaim? userChargebackToClaim : userChargeback)?.value?.toFixed(2)}} {{(!!userChargebackToClaim? userChargebackToClaim : userChargeback)?.currency}}</div>
            <div *ngIf="!userChargebackToClaim && chargebackFormatted" style="color: #E4DCD1;"><span i18n>Next payout in:</span>&nbsp;{{chargebackFormatted}}</div>
          </div>
          <div class="info">
            <a [routerLink]="cashbackInfoUrl" rel="noreferrer" routerLinkActive="active">
              <img src="{{licenceService.getKey('icon-info')}}">
            </a>
          </div>
        </div>
        <button round-button filled="filled" [disabled]="!userChargebackToClaim" color="warn" (click)="claimCashback()" i18n>Claim!</button>
      </div>
    </div>

    <div class="items-dark">
      <div class="item-wrapper-dark">
        <div class="item">
          <div class="icon-container-dark">
            <img src="{{licenceService.getKey('profile-my-bonus')}}" />
          </div>
          <div class="text-container">
            <div class="title" i18n>Promo Code</div>
            <div i18n>Manage your bonuses</div>
          </div>
          <!-- <div class="info">
            <a [routerLink]="bonusesUrl" rel="noreferrer" routerLinkActive="active">
              <img src="assets/luckera/icons/icon-info.svg">
            </a>
          </div> -->
        </div>
        <button round-button filled="empty" color="white" i18n [routerLink]="promoCodeUrl" routerLinkActive="active">Proceed</button>
      </div>
      <div class="item-wrapper-dark">
        <div class="item">
          <div class="icon-container-dark">
            <img src="{{licenceService.getKey('profile-my-games')}}" />
          </div>
          <div class="text-container">
            <div class="title" i18n>My games</div>
            <div i18n>Manage your collection</div>
          </div>
          <!-- <div class="info">
            <a [routerLink]="myGamesUrl" rel="noreferrer" routerLinkActive="active">
              <img src="assets/luckera/icons/icon-info.svg">
            </a>
          </div> -->
        </div>
        <button round-button filled="empty" color="white" i18n [routerLink]="myGamesUrl" routerLinkActive="active">Play</button>
      </div>
    </div>

    <div class="divider">
      <mat-divider></mat-divider>
    </div>

    <div class="main-wrap">
      <div fxLayout="row" fxLayoutAlign="space-between center" class="edit-profile-wrapper wrapper">
        <div>
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
            <img src="{{licenceService.getKey('edit-profile-icon')}}">
            <div>
              <div class="title" i18n>Edit profile</div>
              <div class="description" i18n>Edit your profile picture and other data</div>
            </div>
          </div>
        </div>
        <button round-button class="capitalize-button button" filled="empty" color="white" [routerLink]="editProfileUrl" routerLinkActive="active" i18n>Proceed</button>
      </div>

      <div fxLayout="row" fxLayoutAlign="space-between center" class="edit-profile-wrapper wrapper">
        <div>
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
            <img src="{{licenceService.getKey('change-password-icon')}}">
            <div>
              <div class="title" i18n>Change password</div>
              <div class="description" i18n>Manage security of your account</div>
            </div>
          </div>
        </div>
        <button round-button class="capitalize-button button" filled="empty" color="white" [routerLink]="changePasswordUrl" routerLinkActive="active" i18n>Proceed</button>
      </div>
    </div>
  </div>
</div>